import React, { useEffect, useState } from "react";
import { Form, ListGroup } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySiteManagementServices } from "../../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import InvestigatorSignature from "./InvestigatorSignature";
import ViewSubjectFormReportList from "./ViewSubjectFormReportList";

const SubjectReport = () => {
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjectId, setSubjectId] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [subjectLoader, setSubjectLoader] = useState(false);
  const [reportLoader, setReportLoader] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [siteId, setSiteId] = useState("");
  const [openModule, setOpenModule] = useState("formReport");
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudySiteBasedonAccess = async () => {
    setLoading(true);
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(
      studyId,
      "edc",
      StudyMode
    );
    setSiteList(data?.data || []);
    setSiteId((data?.data || [])[0]?.siteId)
    setLoading(false);
  };

  const getStudySubjectRowData = async () => {
    setSubjectLoader(true)
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
    setSubjectLoader(false)
  }

  const getFormReportBasedonSubject = async () => {
    setReportLoader(true)
    setFormData([])
    let data = await studySubjectManagementServices.getFormReportBasedonSubject(studyId, siteId, subjectId, StudyMode)
    if (data === "AbortError") {
      setReportLoader(true);
    } else {
      setFormData(data?.data || []);
      setReportLoader(false);
    }
  }

  useEffect(() => {
    getStudySiteBasedonAccess();
  }, [studyId]);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRowData();
    }
  }, [siteId]);
  useEffect(() => {
    if (subjectId && siteId) {
      getFormReportBasedonSubject();
    }
  }, [subjectId, siteId]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack px-2"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <Form.Select onChange={(e) => setSiteId(e.target.value)} style={{ width: 200 }}>
            <option>Select Site</option>
            {siteList?.map(siteData => (
              <option selected={siteId === siteData?.siteId} value={siteData?.siteId}>{siteData?.row?.SITEID}</option>
            ))}
          </Form.Select>
        </div>
        {(subjectId && siteId) &&
          <div className="hstack gap-2">
            <button className={`updateProfile ${openModule === "formReport" && "activee"}`} style={{ fontSize: 12 }} onClick={() => setOpenModule("formReport")}>
              Form Report
            </button>
            <button className={`updateProfile ${openModule === "investigatorSignature" && "activee"}`} style={{ fontSize: 12 }} onClick={() => setOpenModule("investigatorSignature")}>
              Investigator Signature
            </button>
          </div>
        }
      </div>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        className="position-relative bg-white"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {loading || subjectLoader ? (
          <PageLoader />
        ) : subjectList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Please Select Site."} />
          </div>
        ) : (
          <ListGroup className="p-2">
            {subjectList?.map((subject, index) => (
              <ListGroup.Item
                action
                title={subject?.row?.SUBJECTID || subject?.row?.RANDOMNUMBER || subject?.row?.SCREENID}
                onClick={() => {
                  setSubjectId(subject?.subjectId);
                  setSubjectName(subject?.row?.SUBJECTID || subject?.row?.RANDOMNUMBER || subject?.row?.SCREENID);
                }}
                key={index}
                style={{ padding: "7px 0px 7px 10px" }}
                className={`hstack ${subjectId === subject?.subjectId ? "selectedMenu" : "bg-white"
                  }`}
              >
                <span>{subject?.row?.SUBJECTID || subject?.row?.RANDOMNUMBER || subject?.row?.SCREENID}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        {openModule === "formReport" &&
          <>
            {reportLoader ? (
              <PageLoader />
            ) : !subjectId ? (
              <NoDataFoundTable MSG={`Click to view Report!`}/>
            ) : (
              <ViewSubjectFormReportList
                formData={formData}
                subjectName={subjectName}
              />
            )}
          </>
        }
        {openModule === "investigatorSignature" &&
          <InvestigatorSignature
            subjectId={subjectId}
            siteId={siteId}
            studyId={studyId}
            StudyMode={StudyMode}
          />
        }
      </SplitPane>
    </>
  );
};

export default SubjectReport;
